import type {
    WebMcpListResponse,
    WebMcpDetailItem,
    WebMcpEnableData,
} from '../types';

export const McpApiService = Symbol('McpApiService');

export interface McpApiService {
    getList(): Promise<WebMcpListResponse>;
    getDetail(name: string): Promise<WebMcpDetailItem>;
    enable(name: string): Promise<WebMcpEnableData>;
    disable(name: string): Promise<WebMcpEnableData>;
}
